import { createApp } from 'vue'
import App from './App.vue'


// 路由
import router from './router/index'
// store ~ 状态控制
import store from './store/index'
// 通用样式
import './assets/css/common.css';
// 页面访问白名单设置
import './permission'
import { toast } from "./components/toast/index";


interface StoreIdl {
	commit: (name: string, value: any) => void
}

import '@vue/runtime-core'
declare module '@vue/runtime-core' {
    interface ComponentCustomProperties {
        $store: StoreIdl
        $toast: (text: string) => void
        gdp: any
    }
}
/**
 *   挂载使用方式，如下： 
 *   1.直接链式
 *   2.单独分离
 */

// 单独分离
const app = createApp(App);
app.config.globalProperties.$toast = toast;
app.use(router);
app.use(store);
app.mount('#app')